import axios from "./index";

class common {
  //获取城市
  static getAllStation(params) {
    return axios.get("/business-trains/trains/getAllStation", { params: params });
  }

  static login(params) {
    return axios.post(`/business-account/account/login`, params);
  }


  static getMenu() {
    return axios.get(`/business-trains/apps/list`);
  }

  static getCallback(params) {
    return axios.get(`/business-trains/notify/list/${params.appid}/${params.env}`);
  }

  static saveUrl(params) {
    return axios.post(`/business-trains/notify/save`,params);
  }

  static pushUrl(appId) {
    return axios.post(`/business-trains/notify/push/${appId}`);
  }

  

  
}

export default common;
